import React, {Component} from 'react';
import styled from 'styled-components';
import {
  LargeTitle,
  InfoParagraph,
  SmallMargin,
  lightest,
  Contain,
  MediumTitle,
  gray
} from '../Tools/Variables';

const Wrapper = styled.div `
text-align:right;
max-width: 600px;
margin-right: 7%;
  
`;

class Sustainability extends Component {
  render() {
    return (

      <React.Fragment>
        <Contain>
          <div
            style={{
            display: 'flex',
            justifyContent: 'flex-end'
          }}>

            <Wrapper>
              <MediumTitle style={{
                color: gray
              }}>
                Du Behöver:
              </MediumTitle>
              <LargeTitle>
                Värdens bästa säng,
              </LargeTitle>
              <LargeTitle>
                varje dag. Hela livet.
              </LargeTitle>
              <SmallMargin/>
              <InfoParagraph
                style={{
                float: 'right',
                maxWidth: 300
              }}>
                Slipp oron att din säng kommer mattas av med åren. Lorem ipsum dolor sit amet,
                scripta legimus an eam, hinc dolore euripidis cu vel. Ne integre imperdiet nam,
                est insolens voluptaria cu.</InfoParagraph>
            </Wrapper>
          </div>

        </Contain>
      </React.Fragment>

    );
  }
}

export default Sustainability;



// WEBPACK FOOTER //
// ./src/Home/Sustainability.js